<template>
	<div>
	<!-- <div> -->

		<b-form-file
			class="mb-3"
			:ref="'edit_file_' + id"
			v-if="extern_file"
			accept=".csv, .txt,.xlsx,.xls"
			@change="addTabulator"
			placeholder="Importer un csv ou un xlsx pour édition"></b-form-file>

		<div v-if="tabulator_data.length > 0 && select_mode" class="d-flex align-items-center mb-3" style="gap: 8px; flex-wrap: wrap;">
			<b-button @click="mode = 'tabulator'" :variant="mode == 'tabulator' ? 'outline-primary': ''" >Tableau</b-button>
			<b-button @click="currentLineIndex = 1; mode = 'individual'" :variant="mode == 'individual' ? 'outline-primary': ''">Vue individuelle</b-button>
			<small v-if="name_file_tabulator" class="text-muted ml-1"><i class="fas fa-file-csv mr-1"></i>{{ name_file_tabulator }}</small>
		</div>

		<b-button style="margin-bottom: 10px" v-if="default_visible == false && visible == true" @click="visible = false"><i class="fas fa-eye-slash"></i> données</b-button>
		<b-button style="margin-bottom: 10px" v-if="default_visible == false && visible == false" @click="visible = true"><i class="fas fa-eye"></i> données</b-button>

		<b-collapse v-model="visible" :id="'collapse' + id">
			<div v-show="!hidden && mode == 'tabulator'"
			id="tabulator-holder"
			v-observe-visibility="{
				callback: (isVisible) => { if (isVisible) redraw(!wasRedrawn) },
			}">
				<div ref="tabulator" :id="id" style="overflow:visible !important;"></div>
			</div>

			<div v-show="!minimal && !hidden && mode == 'tabulator'" class="mb-3 flex justify-between">
				<b-button variant="link" v-b-toggle="'collapse-action' + id" v-if="!rules || (rules.filters == true || rules.download == true || rules.add_column == true || rules.add_line == true)">
					<i class="fas fa-cogs"> </i>
				</b-button>

				<!-- * slider pour lignes par page  -->
				<!-- * affiché que si le tabulator est chargé  -->
				<div class="flex items-center" v-if="tabulator_data.length > 0">
					<div class="mx-3">Lignes par page:</div>

					<b-dropdown
						:text="paginationSize.toString() + ' lignes'"
						class="">
						<b-dropdown-item
							v-for="n in 5"
							@click="() => (paginationSize = n * 10)"
							:key="n">
							{{ n * 10 }} lignes
						</b-dropdown-item>
					</b-dropdown>
				</div>
			</div>

			<b-collapse v-show="!hidden" :id="'collapse-action' + id">

				<b-tabs>
					<b-tab title="Configuration" v-if="(!rules || rules.download == true) && download">
						<b-col>
							<br />
							<div class="d-flex align-items-center mb-3" style="gap:8px">
								<small class="text-muted text-nowrap"><i class="fas fa-file-csv mr-1"></i>Nom :</small>
						<b-form-input size="sm" v-model="name_file_tabulator" style="max-width:220px" placeholder="data.csv" @keydown="preventForbiddenChars" @change="onFilenameChange" />
							</div>
							<b-button @click="dowloadCSV"><i class="fas fa-file-download"></i> csv</b-button>
							&nbsp;
							<b-button @click="dowloadExcel"><i class="fas fa-file-download"></i> xlsx</b-button>
						</b-col>
					</b-tab>
					<b-tab v-if="!rules || rules.filters == true" title="Recherche"
						v-show="tabulator_options.columns.length > 0"
						class="search-col">
						<div class="mb-2 space-x-2 flex">
							<div
								v-for="(colFilter, i) in columnFilters"
								:key="colFilter"
								@click="() => removeColumnFilter(i)"
								class="bg-blue-600 rounded-sm text-white hover:bg-blue-700 hover:cursor-pointer hover:line-through">
								{{ colFilter }}
							</div>
						</div>

						<div class="mb-2">
							<span>
								Filtrer {{ filterColumns ? "colonnes" : "lignes" }}:
							</span>
							<span
								class="cursor-pointer opacity-30 line-through"
								@click="() => (filterColumns = !filterColumns)">
								{{ filterColumns ? "lignes" : "colonnes" }}
							</span>
						</div>
						<autocomplete
							v-show="filterColumns"
							base-class="autocomplete"
							ref="columnFilter"
							class="w-[30%] mb-2 rounded-lg focus:outline-none"
							@submit="(val) => addColumnFilter(val)"
							:search="searchCol"
							:autoSelect="true">
						</autocomplete>

						<div class="flex" v-show="!filterColumns">
							<b-form-input
								class="w-25"
								v-model="data_search"></b-form-input>
							&nbsp;
							<b-button v-on:click="search()"
								><i class="fas fa-search"></i> recherche</b-button
							>
						</div>
					</b-tab>
					<b-tab v-if="(!rules || (rules.add_column == true || rules.add_line == true)) && editor != false && row_updates" title="Insertion">
						<br />

						<b-form-input style="display:inline" v-if="!rules || rules.add_column == true"
							class="w-25"
							:list="'my-list-column' + id"
							v-model="name_column"></b-form-input>
						<datalist :id="'my-list-column' + id">
							<option></option>
							<option
								v-for="(item, index) in column_import_opt"
								:key="item">
								{{ index }}
							</option>
						</datalist>

						<b-button variant="link" v-if="!rules || rules.add_column == true" v-on:click="addColumn()"
							><i class="fas fa-plus-circle"></i>
							colonne</b-button
						>

						<hr />

						<div v-for="(column, idx) in tabulator_options.columns" :key="idx">
							<span v-show="!hidden_columns[column.title]"> {{ column.title }} </span><b-textarea v-show="!hidden_columns[column.title]" :rows="1" v-model="new_line[column.title]"></b-textarea>
						</div>

						<b-button variant="link"
							v-if="tabulator_options.columns.length > 0 && (!rules || rules.add_line == true)"
							v-on:click="addLine()"
							><i class="fas fa-plus-circle"></i> ligne au début</b-button
						>
						&nbsp;
						<b-button variant="link"
							v-if="tabulator_options.columns.length > 0 && (!rules || rules.add_line == true)"
							v-on:click="addLine(true)"
							><i class="fas fa-plus-circle"></i> ligne à la fin</b-button
						>

					</b-tab>
					<b-tab title="Visibilité des colonnes">

						<div v-for="(column, idx) in tabulator_options.columns" :key="idx">
							<b-button @click="hide_column(column.title)" variant="link"><i :class="hidden_columns[column.title] ? 'fas fa-eye-slash' : 'fas fa-eye'"></i></b-button>&nbsp;{{ column.title }}
						</div>

						<b-button variant="link" @click="hide_all">Tout cacher</b-button>
						<b-button variant="link" @click="show_all">Tout montrer</b-button><br />					
						Cacher les colonnes ayant moins de &nbsp;<b-input variant="link"style="width: 100px; display:inline" type="number" v-model="nb_items"></b-input>&nbsp;valeurs&nbsp;<b-button variant="link" @click="hide_column_items">Appliquer</b-button>
					</b-tab>
				</b-tabs>

			</b-collapse>

			<b-modal :title="view_file ? 'Fichier' : 'Texte'" size="xl" ok-only :id="'et-'+ id" @hide="hide_modal">
				<b-textarea v-show="!view_file" rows="10" v-model="edit_text"></b-textarea>
				<viewFile v-if="view_file" :data="view_file"></viewFile>           
				<viewFile v-else-if="edit_text.startsWith('http') && (edit_text.endsWith('.jpeg') || edit_text.endsWith('.jpg') || edit_text.endsWith('.png'))" :getDownload="false" :data="edit_text"></viewFile>
			</b-modal>

			<div v-if="tabulator_data.length && mode == 'individual'">

				<b-pagination
					v-model="currentLineIndex"
					:total-rows="tabulator_data.length"
					:per-page="1"
					aria-controls="line-navigation"
				></b-pagination>

				<div v-for="(column, idx_column) in tabulator_options.columns" :key="idx_column">
					{{ column.field }}

					<div v-if="(columns_type && columns_type[column.field] && columns_type[column.field].type == 'html') || (typeof tabulator_data[currentLineIndex - 1][column.field] === 'string' && tabulator_data[currentLineIndex - 1][column.field].includes('<') && tabulator_data[currentLineIndex - 1][column.field].includes('>'))">
						<b-container style="margin: 0; padding: 0; max-width: none;">
							<b-row>
								<b-col>
									<ace_editor :height="tabulator_data[currentLineIndex - 1][column.field].length / 5 < 500 ? tabulator_data[currentLineIndex - 1][column.field].length / 5 : 500" mode="html" :code="tabulator_data[currentLineIndex - 1][column.field]" @update="tabulator_data[currentLineIndex - 1][column.field] = $event"></ace_editor>
								</b-col>
								<b-col>
									<contenteditable :contenteditable="true" tag="div" :noHTML="false" v-model="tabulator_data[currentLineIndex - 1][column.field]" style="max-height: 500px; overflow-y: auto; padding:10px"></contenteditable>
								</b-col>
							</b-row>
						</b-container>
					</div>
					<b-textarea v-else
						rows="2"
						max-rows="10"
						v-model="tabulator_data[currentLineIndex - 1][column.field]" />
				</div>

				<br />

				<b-pagination
					v-model="currentLineIndex"
					:total-rows="tabulator_data.length"
					:per-page="1"
					aria-controls="line-navigation"
				></b-pagination>
			</div>

			<div v-if="false">
				<div class="card-grid">
					<div
						v-for="(rowData, rowIndex) in paginatedData"
						:key="rowIndex"
						class="card"
					>
						<div class="card-content">
							Ligne {{ rowIndex + 1 + (currentPage - 1) * pageSize }}
							<div
								v-for="(column, idx_column) in tabulator_options.columns"
								:key="idx_column"
							>
								<strong>{{ column.field }}:</strong>
								<b-textarea
									v-model="rowData[column.field]"
								></b-textarea>
							</div>
						</div>
					</div>

					<div v-if="tabulator_data.length > 0 && tabulator_data.length > pageSize">
						<b-pagination
							v-model="currentPage"
							:total-rows="tabulator_data.length"
							:per-page="pageSize"
							aria-controls="table"
							align="center"
						></b-pagination>
					</div>
				</div>
			</div>
		</b-collapse>
	</div>
</template>

<script>
	const chardet = require("chardet");

	import Tabulator from 'tabulator-tables/dist/js/tabulator.min.js';
	import * as CSV from "csv-string";
	import uniqueId from "lodash.uniqueid";
	import Autocomplete from "@trevoreyre/autocomplete-vue";
	
	var XLSX = require("xlsx");
	var clone = require("clone");

	import Vue from 'vue';
    import $ from "jquery";
    import * as json2csv from "json2csv";

	import store from "../store";
	import images from "./images";
	import videos from "./videos";
	import categories from "./categories";
	import ace_editor from "./ace_editor.vue";
	import viewFile from "./viewFileSimplify.vue";
	import categories_splash from "./categories_splash";

	export default {
		name: "edit_tabulator",
		components: {
			ace_editor,
			autocomplete: Autocomplete,
			images,
			videos,
			categories,
			categories_splash,
			viewFile
		},
			data: function () {
			return {
				mode: "tabulator",

				currentPage: 1,
				pageSize: 8,
				currentLineIndex: 1,
				nb_items: 1,
				rules: null,

				tabulator: null, // Instance Tabulator

				tabulator_data: [],
				tabulator_options: {
					columns: [],
				},
				pagination: 10,
				name_column: "",
				line: {},
				input_menu: "",
				id: uniqueId(""),

				column_import_opt: [],
				option_delete: false,
				selected: "active",

				data_search: "",
				index: "id",

				paginationSize: 10,

				initialColumns: [],
				name_columns: [],
				columns_hide: [],
				columns_obj: {},
				columnFilters: [],
				filterColumns: false,

				wasRedrawn: false,
				idx_images: 0,
				idx_videos: 0,

				edit_text: "",
				edit_cell: null,

				prev_page: null,
				is_prev_page: false,
				page: 0,

				elems: {},
				objs_update: [],

				view_file: false,
				change_to_apply: {},

				new_line: {},

				hidden_columns: {},
				visible: true,
				tabulatorReady: false,
				savedScrollLeft: 0,

				name_file_tabulator: ""
			};
		},
		computed: {
			paginatedData() {
				const start = (this.currentPage - 1) * this.pageSize;
				const end = start + this.pageSize;
				return this.tabulator_data.slice(start, end);
			},
		},
		props: {
			select_mode: {
				defaut: false
			},
			hidden: {
				default: false
			},
			extern_file: {
				default: true,
				type: Boolean,
			},
			selectable: {
				default: false,
				type: Boolean,
			},
			minimal: {
				default: false
			},
			editor: {
				default: true
			},
			download: {
				default: true
			},
			hide_less_column: {
				default: false
			},
			columns_type: {
				default: () => {}
			},
			black_white_lists_edit: {},
			categories: {
				default: () => null
			},
			categories_splash: {
				default: () => null
			},
			row_updates: {
				default: () => true
			},
			_index: {
				default: "id"
			},
			default_visible: {
				default: true,
				type: Boolean
			},
			filename: {
				default: null,
				type: String
			}
		},
		watch: {
			_index: {
				handler() {
					this.tabulator_options.index = this._index;
					this.index = this._index;
				}
			},
			tabulator_data: {
				deep: true,
				handler() {
					//console.log(this.get_data())

                    // TODO penser à redraw ici lorsque les colonnes changent ?

					if (this.tabulator_data.length > 10)
						this.tabulator_options.pagination = "local";
					else this.tabulator_options.pagination = false;
					var self = this;
					this.$nextTick(() => {
						var data = self.get_data();
						self.$emit("data_length", data.length);
						self.$emit("update", self.id, data);
					});
				},
			},
			paginationSize(newVal, oldVal) {
				this.tabulator_options.paginationSize = newVal;
			},
			name_file_tabulator(val) {
				const sanitized = this._sanitizeFilename(val);
				if (sanitized !== val)
					this.name_file_tabulator = sanitized;
			},
			filename: {
				immediate: true,
				handler(val) {
					if (val)
						this.name_file_tabulator = val;
				}
			},
		},
		methods: {
			getInstance() {
				return this.tabulator;
			},
			hide_modal()
			{
				// Mettre à jour la cellule si nécessaire
				if (this.edit_cell && this.edit_text !== null && this.edit_text !== undefined && typeof this.edit_text !== 'boolean') {
					try {
						// Utiliser row.update() au lieu de cell.setValue() 
						// car setValue() a un bug interne dans Tabulator
						const row = this.edit_cell.getRow();
						const field = this.edit_cell.getColumn().getField();
						const rowData = row.getData();
						rowData[field] = this.edit_text;
						row.update(rowData);
					} catch (error) {
						console.error('Error updating cell:', error);
					}
				}
			},
			new_column(columns, column)
			{
				//console.log(this.columns_type)
				var self = this;
				if (column == "type_action")
					columns.unshift({
						title: column,
						field: column,
						editor: this.editor ? "textarea" : false,
						headerContextMenu: this.headerMenu,
					});
				else if (this.columns_type && this.columns_type[column] && this.columns_type[column].type == "image")
				{
					this.tabulator_options.layout = "fitData"
					var field = column;
					var width = 250;
					if (this.columns_type[column].params && this.columns_type[column].params.width)
						width = this.columns_type[column].params.width;
					columns.push({
						width: width,
						title: column,
						field: column,
						editor: false,
						tooltip: false,
						formatter:function(cell, formatterParams, onRendered){
							var id = uniqueId();
							onRendered(function(){
								document.getElementById("btn" + id).click();
							});
							return "<div style='height:30px; font-size:0px' id='id" + id + "'><button id='btn" + id + "' onclick=\"var event = new CustomEvent('message" + self.id + "', {detail: {id: '" + id + "', index: " + cell.getRow().getPosition() + ", type: 'image', edit: " + ( (self.columns_type[column] && self.columns_type[column].edit) ? 'true' : 'false' ) + ", splash: " + ( (self.columns_type[column] && self.columns_type[column].splash) ? 'true' : 'false' ) + ", black_white_lists_edit: " + ( (self.columns_type[column] && self.columns_type[column].hasOwnProperty("black_white_lists_edit") ? (self.columns_type[column].black_white_lists_edit ? 'true' : 'false') : "null" ) + ", black_white_lists: " + ( (self.columns_type[column] && self.columns_type[column].black_white_lists) ? 'true' : 'false' )) + ", name: '" + field.replace(/'/, "\'") + "'}}); window.dispatchEvent(event);\">" + cell.getValue() + "</button></div>";
						},
						headerContextMenu: this.headerMenu,
					});
					this.columns_obj[field] = columns.length - 1;
				}
				else if (this.columns_type && this.columns_type[column] && this.columns_type[column].type == "video")
				{
					this.tabulator_options.layout = "fitData"
					var field = column;
					var width = 250;
					if (this.columns_type[column].params && this.columns_type[column].params.width)
						width = this.columns_type[column].params.width;
					columns.push({
						width: width,
						title: column,
						field: column,
						editor: false,
						tooltip: false,
						formatter:function(cell, formatterParams, onRendered){
							var id = uniqueId();
							onRendered(function(){
								document.getElementById("btn" + id).click();
							});
							return "<div style='height:30px; font-size:0px' id='id" + id + "'><button id='btn" + id + "' onclick=\"var event = new CustomEvent('message" + self.id + "', {detail: {id: '" + id + "', index: " + cell.getRow().getPosition() + ", type: 'video', edit: " + ( (self.columns_type[column] && self.columns_type[column].edit) ? 'true' : 'false' ) + ", black_white_lists_edit: " + ( (self.columns_type[column] && self.columns_type[column].hasOwnProperty("black_white_lists_edit") ? (self.columns_type[column].black_white_lists_edit ? 'true' : 'false') : "null" ) + ", black_white_lists: " + ( (self.columns_type[column] && self.columns_type[column].black_white_lists) ? 'true' : 'false' )) + ", name: '" + field.replace(/'/, "\'") + "'}}); window.dispatchEvent(event);\">" + cell.getValue() + "</button></div>";
						},
						headerContextMenu: this.headerMenu,
					});
					this.columns_obj[field] = columns.length - 1;
				}
				else if (this.columns_type && this.columns_type[column] && this.columns_type[column].type == "category")
				{
					this.tabulator_options.layout = "fitData"
					var field = column;
					columns.push({
						width: this.columns_type[column].params.width || 250,
						title: column,
						field: column,
						editor: false,
						tooltip: false,
						formatter:function(cell, formatterParams, onRendered){
							var id = uniqueId();
							onRendered(function(){
								document.getElementById("btn" + id).click();
							});
							return "<div style='height:50px; font-size:0px' id='id" + id + "'><button id='btn" + id + "' onclick=\"var event = new CustomEvent('message" + self.id + "', {detail: {id: '" + id + "', index: " + cell.getRow().getPosition() + ", type: 'category', edit: " + ( (self.columns_type[column] && self.columns_type[column].edit) ? 'true' : 'false' ) + ", black_white_lists: " + ( (self.columns_type[column] && self.columns_type[column].black_white_lists) ? 'true' : 'false' ) + ", name: '" + field.replace(/'/, "\'") + "'}}); window.dispatchEvent(event);\">" + cell.getValue() + "</button></div>";
						},
						headerContextMenu: this.headerMenu,
					});
					this.columns_obj[field] = columns.length - 1;
				}
				else if (this.columns_type && this.columns_type[column] && this.columns_type[column].type == "category_splash")
				{
					this.tabulator_options.layout = "fitData"
					var field = column;
					columns.push({
						width: this.columns_type[column].params.width || 250,
						title: column,
						field: column,
						editor: false,
						tooltip: false,
						formatter:function(cell, formatterParams, onRendered){
							var id = uniqueId();
							onRendered(function(){
								document.getElementById("btn" + id).click();
							});
							return "<div style='height:30px; font-size:0px' id='id" + id + "'><button id='btn" + id + "' onclick=\"var event = new CustomEvent('message" + self.id + "', {detail: {id: '" + id + "', index: " + cell.getRow().getPosition() + ", type: 'category_splash', edit: " + ( (self.columns_type[column] && self.columns_type[column].edit) ? 'true' : 'false' ) + ", black_white_lists: " + ( (self.columns_type[column] && self.columns_type[column].black_white_lists) ? 'true' : 'false' ) + ", name: '" + field.replace(/'/, "\'") + "'}}); window.dispatchEvent(event);\">" + cell.getValue() + "</button></div>";
						},
						headerContextMenu: this.headerMenu,
					});
					this.columns_obj[field] = columns.length - 1;
				}
				else if (this.columns_type && this.columns_type[column] && this.columns_type[column].type == "file")
				{
					this.tabulator_options.layout = "fitData"
					var field = column;
					columns.push({
						width: this.columns_type[column].params.width || 250,
						title: column,
						field: column,
						editor: false,
						tooltip: false,
						cellClick: function (e, cell) {
							//console.log("cellClick viewfile")

							self.view_file = cell.getValue();
							self.edit_cell = null;  // Réinitialiser pour éviter setValue sur mauvaise cellule
							self.edit_text = "";

							self.$bvModal.show("et-"+self.id);

						},
						headerContextMenu: this.headerMenu,
					});
					this.columns_obj[field] = columns.length - 1;
				}
				else if (this.columns_type && this.columns_type[column])
				{
					var new_column = {
						maxWidth: 250,
						minWidth: 100,
						title: column,
						field: column,
						editor: this.editor ? "textarea" : false,
						headerContextMenu: this.headerMenu,
						widthGrow: 1,
						tooltip: function(e, cell) { return cell.getValue(); }, //show full cell value on hover
					};

					if (this.columns_type[column] && this.columns_type[column].params)
					{
						if (this.columns_type[column].params.hasOwnProperty("formatter"))
							new_column.formatter = this.columns_type[column].params.formatter;
						if (this.columns_type[column].params.hasOwnProperty("editor"))
							new_column.editor = this.columns_type[column].params.editor;
						if (this.columns_type[column].params.hasOwnProperty("editorParams"))
							new_column.editorParams = this.columns_type[column].params.editorParams;
						if (this.columns_type[column].params.width)
							new_column.width = this.columns_type[column].params.width;
					}

					columns.push(new_column);
				}
				else
					columns.push({
						maxWidth: 500,
						minWidth: 100,
						title: column,
						field: column,
						editor: this.editor ? "textarea" : false,
						headerContextMenu: this.headerMenu,
						widthGrow: 1,
						tooltip: function(e, cell) { return cell.getValue(); }, //show full cell value on hover
					});

				return columns;
			},
			hide_column(column)
			{
				var tabulator_column = this.tabulator.getColumn(column);

				if (!this.hidden_columns[column])
				{
					tabulator_column.hide();
					this.$set(this.hidden_columns, column, true);
				}
				else
				{
					tabulator_column.show();
					this.$delete(this.hidden_columns, column);
				}
			},
			hide_column_items()
			{
				var columns = this.tabulator.getColumns();

				for (let column of columns) {
					var nb = 0;

					for (var i = 0; i < this.tabulator_data.length; i++)
					{
						if (this.tabulator_data[i][column.getField()])
							nb++;
						if (nb > this.nb_items)
							break;
					}

					if (nb < this.nb_items)
					{
						column.hide();
						this.$set(this.hidden_columns, column.getDefinition().title, true);
					}
					/*else
					{
						column.show();
						if (this.hidden_columns[column.getDefinition().title])
							this.$delete(this.hidden_columns, column.getDefinition().title);
					}*/
				}
			},
			hide_all()
			{
				var columns = this.tabulator.getColumns();

				for (let column of columns) {
					column.hide();
					this.$set(this.hidden_columns, column.getDefinition().title, true);
				}
			},
			show_all()
			{
				var columns = this.tabulator.getColumns();

				for (let column of columns) {
					column.show();
					if (this.hidden_columns[column.getDefinition().title])
						this.$delete(this.hidden_columns, column.getDefinition().title);
				}
			},
			applyColumnFilters() {
				var columns = this.tabulator.getColumns();

				for (let column of columns) {
					let title = column.getDefinition().title;

					if (this.columnFilters.length === 0) {
						column.show();
					} else {
						for (let i = 0; i < this.columnFilters.length; i++) {
							let colFilter = this.columnFilters[i];

							if (
								title
									.toLowerCase()
									.indexOf(colFilter.toLowerCase()) > -1
							) {
								column.show();
								break;
							} else {
								column.hide();
							}
						}
					}
				}
			},
			removeColumnFilter(i) {
				this.columnFilters.splice(i, 1);
				this.applyColumnFilters();
			},
			addColumnFilter(val) {
				if (val === undefined || this.columnFilters.includes(val))
					return;
				this.columnFilters.push(val);

				this.$refs.columnFilter.value = "";
				this.applyColumnFilters();
			},
			searchCol(input) {
				if (input.length < 1) {
					// this.tabulator_options.columns = this.initialColumns;
					return [];
				}

				let filteredCols = this.initialColumns.filter((col) => {
					return (
						col.title.toLowerCase().indexOf(input.toLowerCase()) >
						-1
					);
				});

				// if (filteredCols.length == 0) {
				//     this.tabulator_options.columns = this.initialColumns;
				// } else {
				//     this.tabulator_options.columns = filteredCols;
				// }

				filteredCols = filteredCols.map((col) => {
					return col.title;
				});

				return filteredCols;
			},
			applyPagination: function () {
				this.tabulator_options.paginationSize = this.pagination;
			},
			headerMenu: function () {
				var menu = [];
				var self = this;
				var columns = this.tabulator.getColumns();

				for (let column of columns) {
					//create checkbox element using font awesome icons
					let icon = document.createElement("i");
					icon.classList.add("fas");
					icon.classList.add(
						column.isVisible() ? "fa-check-square" : "fa-square"
					);

					//build label
					let label = document.createElement("span");
					let title = document.createElement("span");

					title.textContent = " " + column.getDefinition().title;

					label.appendChild(icon);
					label.appendChild(title);

					//create menu item
					menu.push({
						label: label,
						action: function (e) {
							//prevent menu closing
							e.stopPropagation();

							//toggle current column visibility
							column.toggle();

							//change menu item icon
							if (column.isVisible()) {
								icon.classList.remove("fa-square");
								icon.classList.add("fa-check-square");
							} else {
								icon.classList.remove("fa-check-square");
								icon.classList.add("fa-square");
							}
						},
					});
				}

				menu = [
					{
						label: function (component) {
							//component - column/cell/row component that triggered the menu

							return (
								"<input onChange='setInputMenu_edit" +
								self.id +
								"(this.value)' onClick='event.stopPropagation();'></input> Changer les valeurs de la colonne"
							);
						},
						action: function (e, column) {
							var table = self.tabulator;
							var name = column.getDefinition().field;

							var rows = [];
							if (self.selected == "active")
								rows = self.tabulator.getRows();
							else
								rows = self.tabulator.getSelectedRows();
							for (var i = 0; i < rows.length; i++) {
								var data = {};
								data[name] = self.input_menu;
								rows[i].update(data);
							}
						},
					}]

				if (this.row_updates)
				{
					menu.push({
						label: function (component) {
							//component - column/cell/row component that triggered the menu

							return (
								"<input onChange='setInputMenu_edit" +
								self.id +
								"(this.value)' onClick='event.stopPropagation();' value='" +
								component.getDefinition().title +
								"'></input> Changer nom"
							);
						},
						action: function (e, column) {
							var table = self.tabulator;
							var oldName = column.getDefinition().field;
							var newName = self.input_menu;
							
							// Copier les données de l'ancienne colonne vers la nouvelle
							for (var i = 0; i < self.tabulator_data.length; i++) {
								self.tabulator_data[i][newName] = self.tabulator_data[i][oldName];
								self.$delete(self.tabulator_data[i], oldName);
							}
							
							// Mettre à jour la définition de la colonne
							column.updateDefinition({
								field: newName,
								title: newName,
							});
							
							// Mettre à jour les options de colonnes
							var columns = table.getColumnDefinitions();
							self.tabulator_options.columns = columns;
							self.initialColumns = columns;
						},
					});

					menu.push(
					{
						label: "Supprimer colonne",
						action: function (e, column) {
							var name = column.getDefinition().field;
							column.delete();
							var table = self.tabulator;
							var columns = table.getColumnDefinitions();
							var new_columns = [];
							for (var i = 0; i < columns.length; i++) {
								if (columns[i].field != name)
									new_columns.push(columns[i]);
							}
							self.tabulator_options.columns = new_columns;
							self.initialColumns = new_columns;
							//console.log(name)
							for (
								var i = 0;
								i < self.tabulator_data.length;
								i++
							) {
								self.$delete(self.tabulator_data[i], name);
							}
						},
					});
				}
				/*menu.push(
				{
					label: 'colonnes <i class="fas fa-chevron-right"></i>',
					menu: menu,
				});*/

				return menu;
			},
			save() {
				return this.tabulator_data;
			},
			async load(data) {
				await this.set_data(data);
			},
			redraw: function (validate) {
				if (this.tabulator_data.length > 0 && this.tabulator /*&& validate*/) {
                    //console.log("Redrawing tabulator");
					
					// Sauvegarder la position de scroll avant le redraw
					var tabulatorHolder = this.tabulator.element.querySelector('.tabulator-tableholder');
					var savedScrollLeft = tabulatorHolder ? tabulatorHolder.scrollLeft : 0;
					var savedScrollTop = tabulatorHolder ? tabulatorHolder.scrollTop : 0;
					
					this.tabulator.redraw(true);
					
					// Restaurer immédiatement la position de scroll
					this.$nextTick(() => {
						if (tabulatorHolder) {
							tabulatorHolder.scrollLeft = savedScrollLeft;
							tabulatorHolder.scrollTop = savedScrollTop;
						}
					});
					
					this.wasRedrawn = true;
				}
			},
			get_id: function () {
				return this.id;
			},
			get_data: function (blob) {
				// Si des lignes sont sélectionnées, les retourner
				var selectedRows = this.tabulator.getSelectedRows();
				if (selectedRows && selectedRows.length > 0) {
					return this.tabulator.getSelectedData();
				} else {
					return this.tabulator.getData("active");
				}
			},
			get_data_blob: async function () {
				var self = this;

				var data = this.get_data();

				data = json2csv.parse(data, {
					fields: Object.keys(data.length > 0 ? data[0] : []),
					fieldNames: Object.keys(data.length > 0 ? data[0] : []),
				});

				data = new Blob([data], {
					type: "text/plain",
				});

				return data;
			},
			get_data_files: async function (all_files = true) {
				var self = this;

				var data = await this.get_data_blob();

				return [
					new File([data], this._normalizedFilename(), {
						type: "text/csv",
					}),
				];
			},
			_normalizedFilename: function () {
				const name = this.name_file_tabulator || 'data.csv';
				if (name.toLowerCase().endsWith('.csv')) return name;
				if (/\.xlsx?$/i.test(name)) return name.replace(/\.xlsx?$/i, '.csv');
				return name + '.csv';
			},
			preventForbiddenChars: function (event) {
				if (/[/\\:*?"<>|]/.test(event.key))
					event.preventDefault();
			},
			_sanitizeFilename: function (name) {
				// Supprime les caractères interdits dans les noms de fichiers : / \ : * ? " < > |
				return (name || '').replace(/[/\\:*?"<>|]/g, '');
			},
			onFilenameChange: function () {
				if (this.name_file_tabulator) {
					this.name_file_tabulator = this._sanitizeFilename(this.name_file_tabulator);
					if (/\.xlsx?$/i.test(this.name_file_tabulator))
						this.name_file_tabulator = this.name_file_tabulator.replace(/\.xlsx?$/i, '.csv');
					else if (!this.name_file_tabulator.toLowerCase().endsWith('.csv'))
						this.name_file_tabulator = this.name_file_tabulator + '.csv';
				}
				this.$emit('filename_changed', this.name_file_tabulator);
			},
			set_index(index) {
				this.tabulator_options.index = index;
				this.index = index;
			},
			set_option_delete(option_delete) {
				this.option_delete = option_delete;
			},
			set_column_import_opt(column_import_opt) {
				this.column_import_opt = column_import_opt;
			},
			set_pagination: function (pagination = 10) {
				this.paginationSize = pagination;
				this.tabulator_options.pagination = pagination;
			},
			add_data: function(data)
			{
				this.tabulator_data = this.tabulator_data.concat(data);
			},
			eventListener: async function(event){
				var self = this;
				var id = event.detail.id;
				var column = event.detail.name;
				var edit = event.detail.edit;
				var index = event.detail.index;
				var text = document.getElementById("id" + id).textContent;

				if (event.detail.type == "image")
				{
					this.idx_images++;
					let imagesComp = Vue.extend(images)
					let image = new imagesComp({
						propsData: {
							source: text,
							column: column,
							index: index,
							black_white_lists: event.detail.black_white_lists || false,
							idx: this.idx_images,
							edit: edit,
							black_white_lists_edit: event.detail.black_white_lists_edit !== null ? event.detail.black_white_lists_edit : this.black_white_lists_edit,
							splash: event.detail.splash || false
						}
					});
					image.$on('width', (width, column) => {
							var nb = self.columns_obj[column];
							if (width > self.tabulator_options.columns[nb].width)
								self.tabulator_options.columns[nb].width = width;
						});
					image.$on('update', (index, column, categories) => {
						this.$emit("update_cell", index, column, categories);
					});
					image.$mount('#id' + id);
				}
				else if (event.detail.type == "video")
				{
					this.idx_videos++;
					let videosComp = Vue.extend(videos)
					let video = new videosComp({
						propsData: {
							source: text,
							column: column,
							index: index,
							black_white_lists: event.detail.black_white_lists || false,
							idx: this.idx_videos,
							edit: edit,
							black_white_lists_edit: event.detail.black_white_lists_edit !== null ? event.detail.black_white_lists_edit : this.black_white_lists_edit
						}
					});
					video.$on('width', (width, column) => {
							var nb = self.columns_obj[column];
							if (width > self.tabulator_options.columns[nb].width)
								self.tabulator_options.columns[nb].width = width;
						});
					video.$on('update', (index, column, categories) => {
						this.$emit("update_cell", index, column, categories);
					});
					video.$mount('#id' + id);
				}
				else if (event.detail.type == "category")
				{
					let categoriesComp = Vue.extend(categories)
					let category = new categoriesComp({
						propsData: {
							source: text,
							column: column,
							index: index,
							categories: this.categories,
							edit: edit,
							idx: this.idx_images,
						}
					});
					category.$on('update', (index, column, categories) => {
						this.$emit("update_cell", index, column, categories);
					});
					category.$mount('#id' + id);
					this.elems[index + " " + column] = category;
				}
				else if (event.detail.type == "category_splash")
				{
					let categoriesComp = Vue.extend(categories_splash)
					let category = new categoriesComp({
						propsData: {
							source: text,
							column: column,
							index: index,
							categories: this.categories_splash,
							edit: edit,
							idx: this.idx_images,
							params: this.columns_type[column] ? this.columns_type[column].params : null
						}
					});
					category.$on('update', (index, column, categories) => {
						this.$emit("update_cell", index, column, categories);
					});
					category.$mount('#id' + id);
					this.elems[index + " " + column] = category;
				}
			},
			set_data: async function (data, name_columns = null, type) {
				var self = this;

				if (!this.tabulator || !this.tabulatorReady) {
					//console.log("[FILESET] Waiting for tabulator to be ready...");
					var c = true;
					while (c)
					{
						await new Promise(resolve => setTimeout(resolve, 50));
						if (this.tabulator && this.tabulatorReady) {
							c = false;
							//console.log("[FILESET] Tabulator is now ready!");
						}
						else
						{
							//console.log("[FILESET] Tabulator is not ready.");
						}
					}
				}

				//console.log('[SET_DATA] Called with data:', JSON.parse(JSON.stringify(data)), 'length:', data ? data.length : 0);

				this.idx_images = 0;

				if (!Array.isArray(data))
					data = [];

				var fields = Object.keys(data.length > 0 ? data[0] : []);
				//console.log('[SET_DATA] Fields extracted:', fields);
				var columns = [];
				if (this.name_columns)
					this.name_columns = name_columns;
				for (var i = 0; i < fields.length; i++) {
					if (!name_columns || (name_columns && name_columns.includes(fields[i])))
					{
						columns = this.new_column(columns, fields[i]);
					}
				}
				if (this.option_delete) {
					columns.push({
						formatter: "buttonCross",
						width: 40,
						align: "center",
						cellClick: function (e, cell) {
							cell.getRow().delete();
						},
					});
				}
				this.tabulator_data = clone(data);

				//console.log(type)
				//console.log(clone(this.tabulator_data))

				this.tabulator_options.columns = columns;
				this.initialColumns = columns;
				
				//console.log('[SET_DATA] Setting columns and data, tabulatorReady:', this.tabulatorReady);
				
				// Si le tableau est déjà construit, appliquer les colonnes et données immédiatement
				if (this.tabulator && this.tabulatorReady) {
					console.log('[SET_DATA] Tabulator ready, applying columns and data now');
					this.tabulator.setColumns(columns);
					this.tabulator.replaceData(this.tabulator_data);
				}
			},
			set_data_cell(index, column, data, apply)
			{
				var self = this;

				if (apply)
				{
					var obj = {};
					obj[column] = data;
					obj[this._index] = index;
					
					this.objs_update.push(obj)
					//console.log("set_data_cell");
					this.tabulator.updateData(this.objs_update);
					//console.log("set_data_cell - end ");
					this.objs_update = [];
				}
				else
				{
					if(!this.change_to_apply[index])
						this.change_to_apply[index] = {};
					this.change_to_apply[index][column] = data;
				}
			},
			set_data_cell_apply(columns)
			{
				//console.log('tabulator set_data_cell_apply')
				for (var i = 0; i < this.tabulator_data.length; i++)
                {
                    if (this.change_to_apply[this.tabulator_data[i][this.index]])
                    {
                        var keys = Object.keys(this.change_to_apply[this.tabulator_data[i][this.index]]);
                        for (var j = 0; j < keys.length; j++)
                        {
                            this.tabulator_data[i][keys[j]] = this.change_to_apply[this.tabulator_data[i][this.index]][keys[j]];
                        }
                    }
                }
				this.change_to_apply = {};
				if (this.tabulator_data.length > 0 && columns)
					this.set_columns(Object.keys(this.tabulator_data[0]));
				//console.log('tabulator set_data_cell_apply end')
			},
			set_columns: function (columns) {
				//console.log("set columns")

				var _columns = [];
				for (var i = 0; i < columns.length; i++) {
					_columns = this.new_column(_columns, columns[i]);
				}
				if (this.option_delete) {
					_columns.push({
						formatter: "buttonCross",
						width: 40,
						align: "center",
						cellClick: function (e, cell) {
							cell.getRow().delete();
						},
					});
				}
				this.tabulator_options.columns = _columns;
				this.initialColumns = _columns;
			},
			dowloadCSV: function (dowload = true) {
				const tabulatorInstance = this.tabulator;
				this.dowload = true;
				const baseName = (this.name_file_tabulator || this.filename || 'data').replace(/\.[^/.]+$/, '');
				tabulatorInstance.download(
					"csv",
					baseName + ".csv",
					{},
					(this.tabulator.getSelectedRows().length > 0) ? "selected" : "active"
				);
			},
			dowloadExcel: function (dowload = true) {
				const tabulatorInstance = this.tabulator;
				this.dowload = true;
				const baseName = (this.name_file_tabulator || this.filename || 'data').replace(/\.[^/.]+$/, '');
				tabulatorInstance.download(
					"xlsx",
					baseName + ".xlsx",
					{},
					(this.tabulator.getSelectedRows().length > 0) ? "selected" : "active"
				);
			},
			search: async function () {
				function matchAny(data, filterParams) {
					var match = false;

					for (var key in data) {
						if (
							typeof data[key] == "string" &&
							data[key].toLowerCase().includes(filterParams.value.toLowerCase())
						) {
							match = true;
						}
					}

					return match;
				}

				this._filterInProgress = true;
				this.tabulator.setFilter(matchAny, { value: this.data_search });
				this._filterInProgress = false;
			},
		addTabulator: async function (event = null) {
			//console.log("add Tabulator")
			var self = this;

			var file = null;
				if (event.dataTransfer)
					file = event.dataTransfer.files[0];
				else
					file = event.target.files[0];
				if (file)
					this.name_file_tabulator = file.name;
				var str = await file.arrayBuffer();
				if (this.name_file_tabulator && (this.name_file_tabulator.endsWith(".xlsx") || this.name_file_tabulator.endsWith(".xls")))
				{
					// Le tabulator produit du CSV pour les traitements suivants : forcer l'extension à .csv
					this.name_file_tabulator = this.name_file_tabulator.replace(/\.xlsx?$/i, '.csv');
					var workbook = XLSX.read(str, { bookType: "csv", dateNF:'yyyy-mm-dd'});
					self.tabulator_data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {raw:false, defval: ""});
					//console.log(workbook)
					//console.log(self.tabulator_data)
					var columns_keys = Object.keys(self.tabulator_data[0]);
					var columns = []
					for (var i = 0; i < columns_keys.length; i++)
					{
						columns = this.new_column(columns, columns_keys[i])
					}
					self.tabulator_options.columns = columns;
					self.initialColumns = columns;
					
					// Appliquer au Tabulator si déjà construit
					if (self.tabulator && self.tabulatorReady) {
						self.tabulator.setColumns(columns);
						self.tabulator.replaceData(self.tabulator_data);
					}
					
					self.$refs["edit_file_" + self.id].reset();
					self.$emit('loaded');
					self.$emit('filename_changed', self.name_file_tabulator);
				}
				else
				{
					var encoding = chardet.detect(Buffer.from(str));
					var str = new TextDecoder().decode(str);
					var separator = CSV.detect(str);
					if (separator != "," && separator != ";" && separator != "\t")
						separator = ",";
					this.$papa.parse(file, {
						encoding: encoding,
						delimiter: separator,
						header: true,
						skipEmptyLines: true,
						complete: function (results) {
							self.tabulator_data = results.data;
							var fields = results.meta.fields;
							var columns = [];
							for (var i = 0; i < fields.length; i++) {
								columns = self.new_column(columns, fields[i]);
							}
							if (self.option_delete) {
								columns.push({
									formatter: "buttonCross",
									width: 40,
									align: "center",
									cellClick: function (e, cell) {
										cell.getRow().delete();
									},
								});
							}
							self.tabulator_options.columns = columns;
							self.initialColumns = columns;
							
							// Appliquer au Tabulator si déjà construit
							if (self.tabulator && self.tabulatorReady) {
								self.tabulator.setColumns(columns);
								self.tabulator.replaceData(self.tabulator_data);
							}
							
							self.$refs["edit_file_" + self.id].reset();
							self.$emit('filename_changed', self.name_file_tabulator);
						},
					});
				}
			},
			addLine: function (first = false) {
				var data = {};
				for (
					var i = 0;
					i < this.tabulator_options.columns.length;
					i++
				) {
					if (this.new_line[this.tabulator_options.columns[i].title])
						data[this.tabulator_options.columns[i].title] = this.new_line[this.tabulator_options.columns[i].title];
					else 
						data[this.tabulator_options.columns[i].title] = "";
				}
				this.new_line = {};

				if (first)
					this.tabulator_data.push(data);
				else
					this.tabulator_data.unshift(data);

				if (this.tabulator && this.tabulatorReady)
					this.tabulator.replaceData(clone(this.tabulator_data));
			},
			addColumn: function () {
				if (this.name_column.trim()) {
					var colDef = {
						title: this.name_column.trim(),
						field: this.name_column.trim(),
						editor: this.editor ? "textarea" : false,
						width: 200,
						headerContextMenu: this.headerMenu,
					};
					this.tabulator_options.columns.push(colDef);
					this.initialColumns = this.tabulator_options.columns;

					for (var i = 0; i < this.tabulator_data.length; i++) {
						this.tabulator_data[i][this.name_column.trim()] = "";
					}
					if (this.column_import_opt[this.name_column.trim()]) {
						for (var i = 0; i < this.tabulator_data.length; i++) {
							if (!this.tabulator_data[i][this.name_column.trim()])
								this.tabulator_data[i][this.name_column.trim()] =
									this.column_import_opt[this.name_column.trim()];
						}
					}

					if (this.tabulator && this.tabulatorReady) {
						this.tabulator.addColumn(colDef);
						this.tabulator.replaceData(clone(this.tabulator_data));
					}
				}

				var self = this;
				this.$nextTick(() => {
					self.$emit("update", self.id, self.get_data());
				});
			},
			setInputMenu(input_menu) {
				this.input_menu = input_menu;
			},
		},
		destroyed() {
			this.$el.removeEventListener('message' + this.id, this.eventListener);
		},
		mounted: async function () {
			//console.log("edit_tabulator")

			window.addEventListener('message' + this.id, this.eventListener);

			this.$loadScript(
				"https://oss.sheetjs.com/sheetjs/xlsx.full.min.js"
			);

			if (store.state.user.rules && store.state.user.rules.tabulator_button)
				this.rules = store.state.user.rules.tabulator_button;

			var self = this;
			this.resolve = null;

			this.visible = this.default_visible;

			window["setInputMenu_edit" + this.id] = this.setInputMenu;

			this.tabulator_options = {
				layout: "fitData",
				renderVertical: "basic",
				columns: [],
				//columnMaxWidth: 1000,
				addRowPos: "top", //when adding a new row, add it to the top of the table
				history: true, //allow undo and redo actions on the table
				movableColumns: true, //allow column order to be changed
				resizableRows: true, //allow row order to be changed
				data: this.tabulator_data,
				pagination: "local",
				paginationSize: 10,
				selectable: this.selectable,
				downloadRowRange: "selected",
				nestedFieldSeparator: false,
				index: this._index || "id",
				// Tabulator 6 : downloadReady est remplacé par downloadEncoder
				downloadEncoder: function (fileContents, mimeType) {
					//console.log("[EDIT_TABULATOR] downloadEncoder callback called");
					var blob = new Blob([fileContents], {type: mimeType});
					self.tabulator_data_csv = blob;
					if (self.dowload == false) {
						self.resolve();
						return false; // abort download
					} else {
						self.dowload = false;
						return blob;
					}
				},
				rowContextMenu: [
					{
						label: "Sélectionner la ligne",
						action: function (e, row) {
							row.select();
							self.$emit("update", self.id, self.get_data());
						},
					},
					{
						label: "Sélectionner multiples lignes",
						action: function (e, row) {
							var selectedRows = self.tabulator.getSelectedRows();
							if (selectedRows.length > 0) {
								var allRows = self.tabulator.getRows("active");
								var pos_first = allRows.indexOf(selectedRows[selectedRows.length - 1]);
								var pos_last = allRows.indexOf(row);

								if (pos_first > pos_last) {
									var _pos = pos_first;
									pos_first = pos_last;
									pos_last = _pos;
								}

								for (var i = pos_first; i <= pos_last; i++) {
									if (allRows[i]) allRows[i].select();
								}
							} else row.select();

							self.$emit("update", self.id, self.get_data());
						},
					},
					{
						label: "Ne plus sélectionner la ligne",
						action: function (e, row) {
							row.deselect();

							self.$emit("update", self.id, self.get_data());

						},
					},
					{
						label: "Déselectionner toutes les lignes",
						action: function (e, row) {
							self.tabulator.deselectRow();
							self.$emit("update", self.id, self.get_data());
						},
					}
				],
			};

			if (this.row_updates)
			{
				this.tabulator_options.rowContextMenu.push(
				{
					label: "Supprimer ligne",
					action: function (e, row) {
						row.delete();
						self.tabulator_data = self.tabulator.getData();
					}
				});
				this.tabulator_options.rowContextMenu.push(
				{
					label: "Duppliquer ligne",
					action: function (e, row) {
						var newRow = Object.assign({}, row.getData());
						self.tabulator.addRow(newRow, false).then(function () {
							self.tabulator_data = self.tabulator.getData();
						});
					}
				});
			}

			if (this.select_mode)
			{
				this.tabulator_options.rowContextMenu.push(
				{
					label: "Voir ligne",
					action: function (e, row) {
						var rowData = row.getData();
						// Trouver l'index réel dans tabulator_data
						var realIndex = -1;
						for (var i = 0; i < self.tabulator_data.length; i++) {
							if (self.tabulator_data[i] === rowData || 
								(self.index && self.tabulator_data[i][self.index] === rowData[self.index])) {
								realIndex = i;
								break;
							}
						}
						if (realIndex !== -1) {
							self.currentLineIndex = realIndex + 1;
							self.mode = "individual";
						}
					}
				});
			}

			// Créer l'instance Tabulator
			this.$nextTick(() => {
				if (this.$refs.tabulator && !this.tabulator) {
					//console.log('[MOUNTED] Creating Tabulator instance, columns:', this.tabulator_options.columns.length);
					this.tabulator = new Tabulator(this.$refs.tabulator, this.tabulator_options);
					
					// Tabulator 6 : utiliser .on() pour les événements
					this.tabulator.on("tableBuilt", function () {
						//console.log('[TABULATOR] tableBuilt event, data length:', self.tabulator_data.length);
						self.tabulatorReady = true;
					});
					
					this.tabulator.on("dataChanged", function (data) {
						//console.log('[TABULATOR] dataChanged event');
						self.tabulator_data = data;
						// Propager les modifications aux composants parents (ex: étape suivante)
						self.$emit("data", data);
						self.$emit("data_length", data.length);
					});
					
					this.tabulator.on("rowUpdated", function (row) {
						self.$emit("update_row", self.id, row);
					});
					
					this.tabulator.on("rowDeleted", function (row) {
						self.$emit("delete_row", self.id, row);
					});
					
					this.tabulator.on("rowAdded", function (row) {
						self.$emit("add_row", self.id, row);
					});
					
					this.tabulator.on("cellClick", function (e, cell) {
						// Vérifier si la cellule a une valeur valide
						var cellValue = cell.getValue();
						if (!cellValue || typeof cellValue !== 'string') {
							return;
						}
						
						var column = cell.getColumn().getField();
						
						// Ignorer les colonnes sans field (comme le bouton de suppression)
						if (!column) {
							return;
						}
						
						if ((!(self.columns_type && self.columns_type[column] && 
							(
								self.columns_type[column].type == "image" || 
								self.columns_type[column].type == "video" || 
								self.columns_type[column].type == "file")) 
							&& cellValue.length > 100) || (self.columns_type && self.columns_type[column] && self.columns_type[column].type == "list") )
						{
							self.edit_text = cellValue;
							self.edit_cell = cell;
							self.view_file = false;
							self.$bvModal.show("et-"+self.id);
						}
					});
					
					this.tabulator.on("cellEdited", function (cell) {
						//console.log("update_cell")
						self.$emit(
							"update_row",
							self.id,
							cell.getRow(),
							cell.getField()
						);
						self.$emit(
							"update_cell",
							cell.getRow().getIndex(),
							cell.getColumn().getField(),
							cell.getValue()
						);
					});
					
					this.tabulator.on("columnVisibilityChanged", function (column, visible) {
						//column - column component
						//visible - is column visible (true = visible, false = hidden)
						self.$nextTick(() => {
							self.$emit("update", self.id, self.get_data());
						});
					});
					
					this.tabulator.on("rowSelectionChanged", function (data, rows) {
						if (data.length == 0)
							self.selected = "active";
						else
							self.selected = "selected";
						if (self.selected == "active")
						{
							self.$emit("data", self.tabulator_data);
							self.$emit("data_length", self.tabulator_data.length);
						}
						else
						{
							var data = self.tabulator.getSelectedData();
							self.$emit("data", data);
							self.$emit("data_length", data.length);
						}
					});
					
					this.tabulator.on("pageLoaded", function(pageno) {
						if (!self.prev_page)
							self.prev_page = pageno;
						else if (pageno == 1)
							self.is_prev_page = true;
						//console.log("page change : " + pageno)
						//console.log(self.page)
						if (pageno > 1 || (self.page > 1 && pageno == 1))
							document.getElementById(self.id).scrollIntoView();
						self.page = pageno;
						setTimeout(() => {
							//console.log(self.prev_page + " " + self.is_prev_page)
							if (self.prev_page && self.is_prev_page)
							{
								self.tabulator.setPage(self.prev_page);
								//console.log("return to page " + self.prev_page)
							}
							self.prev_page = null;
							self.is_prev_page = false;
						}, "200");
					});
					
					this.tabulator.on("downloadComplete", function() {
						//console.log("[EDIT_TABULATOR] downloadComplete event fired");
					});
					
					// Sauvegarder le scroll horizontal avant le tri
					this.tabulator.on("dataSorting", function(sorters) {
						var tabulatorHolder = self.tabulator.element.querySelector('.tabulator-tableholder');
						self.savedScrollLeft = tabulatorHolder ? tabulatorHolder.scrollLeft : 0;
					});
					
					// Revenir à la page 1 après le tri
					this.tabulator.on("dataSorted", function(sorters, rows) {
						if (self._filterInProgress) return;
						if (self.tabulator.getPageMax() > 0) {
							self.tabulator.setPage(1);
						}
					});
					
					// Restaurer le scroll horizontal après chaque rendu
					this.tabulator.on("renderComplete", function() {
						if (self.savedScrollLeft > 0) {
							var tabulatorHolder = self.tabulator.element.querySelector('.tabulator-tableholder');
							if (tabulatorHolder) {
								tabulatorHolder.scrollLeft = self.savedScrollLeft;
							}
						}
					});
					
				} else if (this.tabulator) {
					//console.log('[MOUNTED] Tabulator already exists, skipping creation');
				} else {
					//console.log('[MOUNTED] No tabulator ref found');
				}
			});
		}
};
</script>

<style>
	.search-col .autocomplete-input {
		height: 2rem !important;
	}

	.center_spinner {
		width: 0%;
		margin: 0 auto;
		margin-top: 30px;
	}

	/* Supprimer les fonds gris/blanc de Tabulator */
	.tabulator {
		background-color: transparent !important;
		border: none !important;
	}

	.tabulator .tabulator-footer {
		background-color: transparent !important;
		border: none !important;
	}

	.tabulator .tabulator-paginator {
		background-color: transparent !important;
	}

	/* Permettre le scroll horizontal */
	.tabulator .tabulator-tableholder {
		overflow-x: auto !important;
	}

	.tabulator-menu {
		position: absolute;
		background-color: white;
		border: 1px solid;
		cursor: pointer;
		padding: 5px;
	}

	.tabulator-menu div:hover {
		background-color: rgb(165, 241, 255);
	}

	.collapse {
		visibility: visible !important
	}

	.card-grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 1rem;
		margin-bottom: 2rem;
	}

	.card {
		border: 1px solid #ddd;
		border-radius: 8px;
		padding: 1rem;
		background-color: white;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.card-content {
		display: flex;
		flex-direction: column;
	}

	/* Fix tooltip scrollbar - remove max-height and overflow */
	.tabulator-tooltip {
		max-height: none !important;
		overflow: visible !important;
		white-space: pre-wrap !important;
		word-wrap: break-word !important;
	}
</style>
